var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({},'div',_vm.$attrs,false),[_c('input',{attrs:{"id":_vm.id,"name":_vm.name,"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.state,"value":_vm.value},on:{"change":_vm.change}}),_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }